// Private App.js
import "./App.css"
import * as React from "react";
import { Admin, CustomRoutes, Login, Resource, } from 'react-admin';
// import { UserList } from "./components/UserList.js";
import { HashRouter as Router, Switch, Route } from 'react-router-dom';
import { Dashboard } from './components/Dashboard'
import LoginPage from "./components/LoginPage"
import authProvider from "./components/authProvider.js";
import { ProjectsDashboardLayout } from "./menu/Layout.js";
import TrainingVideosList from './components/TrainingVideosList';
import VideoDetails from './components/VideoDetails';
import RequestAccessTAW from './components/RequestAccessTAW';
import RequestAccessFormGeneral from "./components/RequestAccessFormGeneral.js";

/*
const AccessDenied = () => (
  <Typography>You don't have the required permissions to access this page.</Typography>
);
*/

const App = () => {
  return (
    <Router>
      <Admin
        loginPage={LoginPage}
        dashboard={Dashboard}
        authProvider={authProvider}
        layout={ProjectsDashboardLayout}
      >
        <CustomRoutes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/dashboard" element={<Dashboard />} noLayout />
          <Route path="/training-videos" element={<TrainingVideosList />} />
          <Route path="/training-videos/:name" element={<VideoDetails />} />
          <Route path="/request-access-taw" element={<RequestAccessTAW />} />
          <Route path="/request-access" element={<RequestAccessFormGeneral />} />
        </CustomRoutes>
      </Admin>
    </Router>
  );
};

export default App;
